// Models
import Model from './Model'

class PaymentReturnData extends Model {
  get schema () {
    return [
      'amount',
      'reason'
    ]
  }
}

export default PaymentReturnData
